export default class SubjectDocumentService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async create(subjectDocument, options) {
    const response = await fetch(`${this.baseUri}/learning/subjectDocument`, {
      body: JSON.stringify(subjectDocument),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/learning/subjectDocument/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/learning/subjectDocument/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/learning/subjectDocument`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async update(id, subjectDocument, options) {
    const response = await fetch(`${this.baseUri}/learning/subjectDocument/${id}`, {
      body: JSON.stringify(subjectDocument),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}